export const THEME_PREFERENCE_KEY = "godiway_theme_preference";
export const THEME_LIGHT = "light";
export const THEME_DARK = "dark";

export function getThemePreference() {
  try {
    const stored = localStorage.getItem(THEME_PREFERENCE_KEY);
    return stored === THEME_DARK ? THEME_DARK : THEME_LIGHT;
  } catch (error) {
    return THEME_LIGHT;
  }
}

export function setThemePreference(theme) {
  try {
    localStorage.setItem(THEME_PREFERENCE_KEY, theme);
  } catch (error) {
    // ignore storage errors
  }
}

export function applyTheme(theme) {
  const root = document.documentElement;
  if (theme === THEME_DARK) {
    root.setAttribute("data-theme", "dark");
  } else {
    root.removeAttribute("data-theme");
  }
}

export function applyThemePreference(theme) {
  const finalTheme = theme === THEME_DARK ? THEME_DARK : THEME_LIGHT;
  setThemePreference(finalTheme);
  applyTheme(finalTheme);
}

export function initTheme() {
  applyTheme(getThemePreference());
}
